<div class="questionWrapper" *ngIf="showComponent">
  <span class='questionHeader'>
    <span class='questionNumberText' [innerHTML]="questionData.numberText"></span>
    <span class='questionText' [innerHTML]="questionData.text"></span>
  </span>
  <div class="grid answersGrid">
    <div class="col-12">
      <div class="grid answersGrid tableHeader">
        <div class="col md">
        </div>
        <div class="md col tableHeader" *ngFor="let column of orderedColumnNames; index as i">
          <div fxLayout="row">
            <span [innerHTML]="column"></span>
            <div *ngIf="columnTooltips[i]">
              <mat-icon [pTooltip]="columnTooltips[i]">info</mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" *ngFor="let row of orderedRowNames; index as i">
        <div class="grid answersGrid">
          <div class="col md" [ngClass]="{'tableRow': i%2 === 0,'tableAlternateRow': i%2 !== 0}">
            <div fxLayout="row">
              <span [innerHTML]="row"></span>
              <div *ngIf="rowTooltips[i]">
                <mat-icon [pTooltip]="rowTooltips[i]">info</mat-icon>
              </div>
            </div>
            <div class="p-col-12" *ngIf="textAnswers[i] != null">
              <input pInputText type="text" class='textAnswer text-input' [style]="{'width': '100%'}" pInputText [(ngModel)]="textAnswers[i].freeText" (focusout)="answerSelected($event, false)" [disabled]="readonly"/>
            </div>
          </div>
          <div class="md col answerCell" *ngFor="let column of orderedColumnNames; index as j"
            [ngClass]="{'tableRow': i%2 === 0,'tableAlternateRow': i%2 !== 0}">
            <span style="width: 100%" *ngIf="columnTypes[j] == columnTypeEnum.Dropdown">
              <p-select
                [options]="selectedOptionsForCell[i][j]"
                [(ngModel)]="selectedAnswerOptionIdList[i][j]"
                optionLabel="label"
                [disabled]="readonly"
                (onChange)="answerSelected($event, true)"
                [autoWidth]="false"
                [style]="{'minWidth':'100%'}"></p-select>
            </span>
            <div style="position: relative; width: fit-content; margin: auto 0;" fxLayout="row" *ngIf="columnTypes[j] == columnTypeEnum.Numerical">
              <p-inputNumber
                [ngModel]="providedTextListMatrix[i][j].text"
                [locale]="locale"
                [minFractionDigits]="numberOfDigitsMatrix[i][j]"
                [maxFractionDigits]="numberOfDigitsMatrix[i][j]"
                inputStyleClass="width-100"
                styleClass="input-number"
                class="input-number"
                (onBlur)="numericalAnswerSelected($event, i, j)"
                [disabled]="readonly">
              </p-inputNumber>
              <span class="hint-style">{{ hints[i][j] }}</span>
            </div>
            <span style="width: 100%" *ngIf="columnTypes[j] == columnTypeEnum.Text">
              <input type="text" pInputText [(ngModel)]="providedTextListMatrix[i][j].text" [disabled]="readonly"
                (focusout)="answerSelected($event, false)"/>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="grid answersGrid">
          <div class="col md">
            <span *ngIf="showColumnSum"><b>{{ sumText }}</b></span>
          </div>
          <div style="width: 25px">
            <!-- for tooltip -->
            <span></span>
          </div>
          <div class="col md" *ngFor="let column of orderedColumnNames; index as j">
            <span style="margin-left: 10px;" *ngIf="showColumnSum && this.columnTypes[j] == columnTypeEnum.Numerical"><b>{{ columnSum[j] | number: '': locale }} {{columnSumSuffix[j]}}</b></span>
          </div>
        </div>
      </div>
      <span class="questionFooter" [innerHTML]="questionData.footerText"></span>
    </div>
  </div>
</div>
